import colors from "@/themes/base/colors";
import typography from "@/themes/base/typography";
import pxToRem from "@/themes/functions/pxToRem";

const { transparent } = colors;
const { size } = typography;

const outlined = {
  base: {
    minHeight: pxToRem(40),
    color: "#344767",
    borderColor: "#344767",
    padding: `${pxToRem(10)} ${pxToRem(24)}`,

    "&:hover": {
      opacity: 0.75,
      backgroundColor: transparent.main,
      color: "#344767",
      borderColor: "#344767",
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    minHeight: pxToRem(32),
    padding: `${pxToRem(6)} ${pxToRem(16)}`,
    fontSize: size.xs,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(47),
    padding: `${pxToRem(12)} ${pxToRem(28)}`,
    fontSize: size.sm,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: {
    backgroundColor: transparent.main,
    borderColor: "#344767",
    color: "#344767",
    "&:hover": {
      backgroundColor: transparent.main,
      borderColor: "#344767",
      color: "#344767",
    },
  },

  secondary: {
    backgroundColor: transparent.main,
    borderColor: "#344767",
    color: "#344767",
    "&:hover": {
      backgroundColor: transparent.main,
      borderColor: "#344767",
      color: "#344767",
    },
  },
};

export default outlined;
